// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"60400355","266":"89e7920f","412":"821fdfbe","442":"e6222b8b","453":"a5d8d466"}[chunkId] + ".chunk.js";
};